exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nNOTE:\nTHESE VARIABLES ARE HERE FOR THE SAKE OF COMPATIBILITY\nPLEASE USE THE ONES UNDER \"NEW NAMING\"\n*/\n\n/* NEW NAMING */\n\n/* families */\n\n/* size */\n\n/* General Indexes */\n\n/* Loading Layer */\n\n/* Component Indexes */\n\n/* Matching Pairs */\n\n/* Draw It */\n\n/* Global Transitions */\n\n.subjects_grades_subtitle__text--1VTGC {\r\n\tcolor: #00a8ff;\r\n\tfont-family: 'avenirroman', Helvetica, Arial, sans-serif;\r\n\tfont-size: 18px;\r\n\tmargin-bottom: 13px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"text": "subjects_grades_subtitle__text--1VTGC"
};